import applogo from "../../assets/applogo.png";

export const AnswerIcon = () => {
    return (
        <img
            src={applogo}
            alt="Answer icon"
            width={32}
            height={32}
            style={{ objectFit: "contain" }}
        />
    );
};
